import { Locales } from '../strings/Locales.js';
// Use the language as default format locale; this is one of the possible choices,
// other options are using undefined (user default) or introducing a user setting.
export var formatLocale = Locales.locale;
export var missingCompact = Locales.format('notApplicableCompact');
export var missingFull = Locales.format('notApplicableFull');
export var resolveMissing = function resolveMissing(compact) {
    return compact ? missingCompact : missingFull;
};

//# sourceMappingURL=sharedConfig.js.map